const M = [
  {
    name: "shortStay",
    zh: "短期停留",
    en: "Short stay"
  },
  {
    name: "restAndStay",
    zh: "休憩小住",
    en: "Rest and stay"
  },
  {
    name: "longStay",
    zh: "长期办公",
    en: "Long stay"
  },
  {
    name: "30Days",
    zh: "30天以上",
    en: "More than 30 days"
  },
  {
    name: "selectAndSend",
    zh: "选择并发送",
    en: "Select and send"
  }
];

export default M;
